import Headroom from 'headroom.js';

document.addEventListener('DOMContentLoaded', () => {
  const myElement = document.querySelector('.navbar');

  const headroom = new Headroom(myElement);

  headroom.init();
});
